import Headroom from "headroom.js";

export default {
  init() {
    // grab an element
    const navbar = document.querySelector(".navbar");
    if(navbar){
       // construct an instance of Headroom, passing the element
      const headroom  = new Headroom(navbar);
      // initialise
      headroom.init();
    }

    $(".activate-menu").on("click", function () {
      $("#mobile-navigation").slideToggle();
      $(this).removeClass("activate-menu");
      $(this).toggleClass("close-trigger");

      $(this).addClass("deactivate-menu");
    });

    $("#mobile-navigation").on("click", function (e) {});

    $("#menu-primary-navigation-1 > li.menu-item-has-children ").prepend(
      '<span class="next"></span>'
    );

    $("#mobile-navigation .menu-item-has-children > a, .next").on(
      "click",
      function (e) {
        e.preventDefault();
        $(this).parent("li").find("> .sub-menu").css({
          left: "0",
        });
      }
    );

    $(".parentTitle").on("click", function (e) {
      $(this).parent("ul").parent("div").css({
        left: "+=100vw",
      });
    });
  },
  finalize() {},
};
